(function(){
  var d=document;
  function $(s,c){return (c||d).querySelector(s)}
  function $$(s,c){return Array.prototype.slice.call((c||d).querySelectorAll(s))}
  // header shrink
  var hd=$('.hd');
  function onScroll(){ if(hd){ hd.classList.toggle('scrolled', window.scrollY>8);} }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  // drawer
  var drawer=$('.drawer');
  function openD(){ if(!drawer)return; drawer.classList.add('open'); d.body.classList.add('no-scroll'); }
  function closeD(){ if(!drawer)return; drawer.classList.remove('open'); d.body.classList.remove('no-scroll'); }
  $$('.js-burger').forEach(function(b){b.addEventListener('click',openD)});
  $$('.js-dclose').forEach(function(b){b.addEventListener('click',closeD)});
  if(drawer){ var ov=$('.drawer__ov',drawer); if(ov) ov.addEventListener('click',closeD); }
  $$('.drawer__nav a, .drawer__cta a').forEach(function(a){a.addEventListener('click',closeD)});
  d.addEventListener('keydown',function(e){if(e.key==='Escape')closeD()});
  // reveal
  var io; if('IntersectionObserver' in window){
    io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}})},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    $$('.reveal').forEach(function(el){io.observe(el)});
  } else { $$('.reveal').forEach(function(el){el.classList.add('in')}); }
  // faq
  $$('.faq__q').forEach(function(q){q.addEventListener('click',function(){
    var it=q.closest('.faq__i'); var a=$('.faq__a',it); var open=it.classList.contains('open');
    if(open){it.classList.remove('open');a.style.maxHeight=null;}
    else{it.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}
  })});
  // gallery
  (function(){
    var slides=$$('.gal__main .s'); var thumbs=$$('.gal__thumbs button'); if(!slides.length)return;
    function go(i){ slides.forEach(function(s,k){s.classList.toggle('on',k===i)}); thumbs.forEach(function(t,k){t.classList.toggle('on',k===i)}); }
    thumbs.forEach(function(t,i){t.addEventListener('click',function(){go(i)})});
  })();
  // videos
  $$('.vcard').forEach(function(c){ var v=$('video',c); var pl=$('.vcard__play',c); if(!v)return;
    function toggle(){ if(v.paused){ $$('.vcard video').forEach(function(o){if(o!==v){o.pause();}}); v.play(); c.classList.add('playing'); } else { v.pause(); c.classList.remove('playing'); } }
    if(pl)pl.addEventListener('click',toggle); v.addEventListener('click',toggle);
    v.addEventListener('pause',function(){c.classList.remove('playing')}); v.addEventListener('play',function(){c.classList.add('playing')});
  });
  // buy box
  (function(){
    var box=$('[data-buybox]'); if(!box)return;
    var tiers=$$('.tier',box); var atc=$$('.js-atc'); var satc=$('.satc');
    var state={variant:box.getAttribute('data-default-variant'),price:'',was:'',label:''};
    function selectTier(t){
      tiers.forEach(function(x){x.classList.remove('on')}); t.classList.add('on');
      state.variant=t.getAttribute('data-variant'); state.price=t.getAttribute('data-price'); state.was=t.getAttribute('data-was'); state.label=t.getAttribute('data-label');
      var np=$('.buy__price .now'); var wp=$('.buy__price .was'); var of=$('.buy__price .off');
      if(np)np.textContent=state.price; if(wp)wp.textContent=state.was; if(of&&t.getAttribute('data-off'))of.textContent=t.getAttribute('data-off');
      if(satc){ var st=$('.satc__meta .t',satc); var sp=$('.satc__meta .p',satc); if(st)st.textContent=state.label; if(sp)sp.innerHTML='<b>'+state.price+'</b> &nbsp;<s>'+state.was+'</s>'; }
    }
    tiers.forEach(function(t){t.addEventListener('click',function(){selectTier(t)})});
    var pre=$('.tier.on',box)||tiers[0]; if(pre)selectTier(pre);
    function add(btn){ if(!state.variant)return; btn.disabled=true; var old=btn.getAttribute('data-label-btn')||btn.textContent; btn.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(state.variant,10),quantity:1}]})})
      .then(function(r){return r.json()}).then(function(){ window.location.href='/checkout'; })
      .catch(function(){ btn.disabled=false; btn.textContent=old; window.location.href='/cart'; }); }
    atc.forEach(function(b){b.setAttribute('data-label-btn',b.textContent);b.addEventListener('click',function(){add(b)})});
    // sticky atc show/hide
    if(satc&&'IntersectionObserver' in window){ var io2=new IntersectionObserver(function(es){es.forEach(function(en){ satc.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top<0); })},{threshold:0}); io2.observe(box); }
  })();
  // before/after slider
  $$('.ba').forEach(function(ba){ var top=$('.ba__top',ba); var hand=$('.ba__hand',ba); var grip=$('.ba__grip',ba); var drag=false;
    function set(x){ var r=ba.getBoundingClientRect(); var p=Math.min(1,Math.max(0,(x-r.left)/r.width)); top.style.clipPath='inset(0 0 0 '+(p*100)+'%)'; hand.style.left=(p*100)+'%'; grip.style.left=(p*100)+'%'; }
    function down(e){drag=true; set((e.touches?e.touches[0].clientX:e.clientX));}
    function move(e){ if(!drag)return; set((e.touches?e.touches[0].clientX:e.clientX)); }
    function up(){drag=false;}
    ba.addEventListener('mousedown',down); ba.addEventListener('touchstart',down,{passive:true});
    window.addEventListener('mousemove',move); window.addEventListener('touchmove',move,{passive:true});
    window.addEventListener('mouseup',up); window.addEventListener('touchend',up);
  });
})();
